import React from 'react'
export default function ChatbaseIframe({ isOpen, onClose, user }) {
    const [isIdentifying, setIsIdentifying] = React.useState(false);

    if (!isOpen) return null;

    const handleIframeLoad = async () => {
        if (user && !isIdentifying) {
            setIsIdentifying(true);
            try {
                // Get JWT token for identity verification
                const response = await fetch('/api/chatbase_token.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include'
                });
                
                if (response.ok) {
                    const data = await response.json();
                    if (data.success && data.token) {
                        // Send token to iframe for identity verification
                        const iframe = document.getElementById('chatbase-iframe');
                        if (iframe && iframe.contentWindow) {
                            iframe.contentWindow.postMessage({
                                type: 'chatbase-identify',
                                token: data.token
                            }, '*');
                        }
                    }
                }
            } catch (error) {
                console.error('Chatbase iframe identity verification error:', error);
            } finally {
                setIsIdentifying(false);
            }
        }
    };

    // Check if user is logged in
    const isLoggedIn = !!user;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1001] p-4">
            <div className="bg-white rounded-xl w-full max-w-2xl h-[80vh] flex flex-col">
                {/* Header */}
                <div className="flex justify-between items-center p-4 border-b border-gray-200">
                    <h2 className="text-xl font-bold text-gray-900">Miners Market Virtual Guide</h2>
                    <button 
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 transition-colors p-2"
                    >
                        <i className="fas fa-times text-xl"></i>
                    </button>
                </div>
                
                {/* Content */}
                <div className="flex-1 overflow-hidden">
                    {isLoggedIn ? (
                        // Logged in user - show iframe
                        <iframe
                            id="chatbase-iframe"
                            src="https://www.chatbase.co/chatbot-iframe/VQo_p3Mr2PWUxRfYV5p2H"
                            className="w-full h-full border-0"
                            onLoad={handleIframeLoad}
                            title="Miners Market Virtual Assistant"
                        />
                    ) : (
                        // Logged out user - show login prompt
                        <div className="flex flex-col items-center justify-center h-full p-8 text-center">
                            <div className="mb-6">
                                <i className="fas fa-comments text-6xl text-blue-600 mb-4"></i>
                            </div>
                            <h3 className="text-xl font-semibold text-gray-900 mb-2">Login Required</h3>
                            <p className="text-gray-600 mb-6">You must be logged in to chat with the Virtual Assistant.</p>
                            <button 
                                onClick={() => {
                                    // Trigger login modal and close chat
                                    onClose();
                                    // We'll need to trigger the login modal - this requires app.js integration
                                    if (window.onShowLogin) {
                                        window.onShowLogin();
                                    }
                                }}
                                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors"
                            >
                                <i className="fas fa-sign-in-alt mr-2"></i>
                                Login to Chat
                            </button>
                            <p className="text-sm text-gray-500">
                                Don't have an account? 
                                <button 
                                    onClick={() => {
                                        onClose();
                                        if (window.onShowSignup) {
                                            window.onShowSignup();
                                        }
                                    }}
                                    className="text-blue-600 hover:text-blue-800 font-medium ml-1"
                                >
                                    Sign up
                                </button>
                            </p>
                        </div>
                    )}
                </div>
                
                {/* Footer */}
                {isLoggedIn && (
                    <div className="p-3 border-t border-gray-200 text-center text-xs text-gray-500">
                        <i className="fas fa-shield-alt mr-1"></i>
                        Protected by TradeSafe &#8226; Responses are for guidance only &#8226; 
                        <a href="/documents/footer/Miners Market Terms of Use.pdf" 
                           target="_blank" 
                           rel="noopener noreferrer"
                           className="text-blue-600 hover:text-blue-800 ml-1">
                            Terms apply
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
}
